import { FilmSlate, SquaresFour, UserCircle, Wallet, FileText } from "@phosphor-icons/react";
import type { AgentType } from "@/features/onboarding/agent-type";
import type { WorkbenchIdentity } from "./identity";

export function workbenchNavigation({ identity, agentType, home, avatarEnabled, authorizationEnabled, showProjects = false }: {
  identity: WorkbenchIdentity; agentType?: AgentType | null; home: string; avatarEnabled: boolean; authorizationEnabled: boolean; showProjects?: boolean;
}) {
  const creator = identity === "creator" || identity === "signed";
  const nav = creator ? [
    { href: home, label: "总览", icon: SquaresFour },
    { href: avatarEnabled ? "/my-avatars" : "/creator/talents", label: "形象上传", icon: UserCircle },
    // 个体与签约授权方统一叫「授权管理」：签约授权方只是把确认权委托给机构，入口名称不变。
    ...(authorizationEnabled ? [{ href: "/my-authorizations", label: "授权管理", icon: FileText }] : []),
    // 项目管理对签约授权方开放为只读：项目由所属机构代为确认，本账号只能看运转，不能点确认 / 驳回。
    ...(creator ? [{ href: "/my-projects", label: "项目管理", icon: FilmSlate }] : []),
    { href: "/contracts", label: "合同管理", icon: FileText },
    { href: "/wallet", label: "钱包收益", icon: Wallet },
  ] : identity === "agent" ? [
    { href: home, label: "总览", icon: SquaresFour },
    { href: "/partner/agent/assets", label: "形象资产", icon: UserCircle },
    // 机构本身也是授权方：授权管理排在项目管理前面（先看授权，再管项目交付），后面才是合同与钱包。
    ...(agentType === "store" ? [] : [{ href: "/partner/agent/authorizations", label: "授权管理", icon: FileText }]),
    ...(agentType === "store" ? [] : [{ href: "/partner/agent/projects", label: "项目管理", icon: FilmSlate }]),
    { href: "/contracts", label: "合同管理", icon: FileText },
    ...(agentType === "store" ? [] : [{ href: "/partner/agent/funds", label: "钱包管理", icon: Wallet }]),
  ] : [
    { href: home, label: "总览", icon: SquaresFour },
    // 选角页与形象广场同一套形象，区别只在卡片下方标了参考报价。
    ...(identity === "brand" || identity === "director"
      ? [{ href: "/partner/casting", label: identity === "director" ? "影视选角" : "电商选角", icon: SquaresFour }]
      : [{ href: "/plaza", label: "形象广场", icon: SquaresFour }]),
    { href: "/partner/authorizations", label: "授权管理", icon: FileText },
    // 项目管理排在授权申请之后：先把授权拿到手，再进项目交付。
    ...(identity === "brand" || identity === "director" ? (showProjects ? [{ href: "/partner/projects", label: "项目管理", icon: FilmSlate }] : []) : []),
    ...(identity === "brand" || identity === "director" ? [{ href: "/contracts", label: "合同管理", icon: FileText }] : []),
  ];
  nav.push({ href: "/account/profile", label: creator ? "个人信息" : "账号设置", icon: UserCircle });
  return nav;
}
